import { MapView } from '@/views/map2d/mapView'

// 地图对象
export default {
    unWatch() {
        return {
            MapView: MapView
        }
    },
    computed: {
        ready() {
            if (this.$store && this.$store.state) {
                return this.$store.state.map.ready
            }
            return null
        },
        map2dChanged() {
            if (this.$store && this.$store.state) {
                return this.$store.state.map.map2dChanged
            }
            return null
        }
    },
    // watch
    watch: {
        map2dChanged: {
            immediate: true,
            handler() {
                if (this.$_onMap2dChange) {
                    this.$_onMap2dChange()
                }
            }
        }
    }
}
